import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useRegisterAdminAnnouncementBannerQuery, {
	type useRegisterAdminAnnouncementBannerQuery$data,
	type useRegisterAdminAnnouncementBannerQuery$variables,
} from './__generated__/useRegisterAdminAnnouncementBannerQuery.graphql.ts';

export const preloadAdminAnnouncementBanner = () =>
	query<
		useRegisterAdminAnnouncementBannerQuery$data,
		useRegisterAdminAnnouncementBannerQuery$variables
	>({
		query: useRegisterAdminAnnouncementBannerQuery,
	});
